import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import { getRandom } from "../common/common";

import CarItemFeatures from "../common/caritemfeatures";

const DealCars = (props) => {
	const { city, stype, cars } = props;

	const carsRandom = getRandom(cars, 8);
	return (
		<div className="featuredCar-section discount space sec">
			<div className="m-container">
				<h2 className="title-car">Xe giảm giá tại {city}</h2>
			</div>
			<div className="m-container">
				<div className="col4-mg20">
					{carsRandom.map((car, i) => {
						return <CarItemFeatures key={i} car={car} city={city} stype={stype} />;
					})}
				</div>
				<Swiper
					modules={[Pagination]}
					pagination={{
						el: ".pagi-related",
						clickable: true,
						dynamicBullets: true,
					}}
					breakpoints={{
						481: {
							slidesPerView: 1.4,
						},
					}}
					slidesPerView={1}
					spaceBetween={10}
					className={`swiper-related-car`}>
					{carsRandom.map((car, i) => {
						return (
							<SwiperSlide key={i}>
								<CarItemFeatures car={car} stype={stype} />
							</SwiperSlide>
						);
					})}
					<div className="swiper-pagination pagi-related" />
				</Swiper>
			</div>
		</div>
	);
};

export default DealCars;
